import * as $ from 'jquery';
import { Analytics } from '@plaudit/analytics';

/**
 * A very simple image gallery.
 * (Note: Before anything like this should be added to NPM the hardcoded configuration needs to be
 *  removed, more hooks are needed to customize galleries, more method (e.g. gallery.next()), etc.
 *  Additionally this should be expanded to be used for 'carousels' too and we should surely first
 *  look for a good existing library to use instead of making one.)
 */
export default class Gallery {
	constructor() {
		const selector_gallery = '.gallery';
		const selector_viewer = '.gallery__view';
		const selector_thumbs = '.gallery__thumb';
		const selector_media = '.gallery__media';
		const analytics = Analytics.getInstance();
		const trackControlEvent = (label: string) => analytics.trackEvent('Image Gallery', 'Control Click', label);

		let $gallery = $(selector_gallery);
		if ($gallery.length === 0) {
			return;
		}

		$gallery.each((index, element) => {
			let currentIndex = 0;
			let removeOldMediaTimeoutID: number = undefined;
			const $elem = $(element);
			const $galleryView = $elem.find(selector_viewer);
			const $galleryThumb = $elem.find(selector_thumbs);

			function removeOldMedia(): void {
				// Remove all but first one
				let $mediaElements = $galleryView.find(selector_media);
				for (let i=1; i < $mediaElements.length; ++i) {
					$($mediaElements[i]).remove();
				}
				$galleryView.attr('status', '');

				removeOldMediaTimeoutID = undefined;
			}

			/**
			 * Activates selected and deactivates others
			 * @param {number} newIndex The index of the slide to activate
			 */
			function activateByIndex(newIndex: number): void {
				currentIndex = newIndex;

				const $thumb = $($galleryThumb[newIndex]);
				const $this = $thumb.find('a');

				const href = $this.attr('href');
				let alt = $this.find('img.rigid').attr('alt') || ' ';
				const $galleryMedia = $galleryView.find(selector_media);

				if ($galleryMedia.attr('src') !== href) {
					if (removeOldMediaTimeoutID !== undefined) {
						clearTimeout(removeOldMediaTimeoutID);
					}

					// Remove 'active' class from all thumbnails and then add to current
					$galleryThumb.attr('status', '');
					$thumb.attr('status', 'active');

					// Load the new media
					$galleryView.attr('status', 'loading');
					const strImage = '<div class="' + selector_media.substr(1) + '"><img src="' + href + '" alt="' + alt + '" /></div>';
					$galleryView.prepend($(strImage));

					// Have media removing removed once done
					removeOldMediaTimeoutID = window.setTimeout(removeOldMedia, 1000);
				}
			}

			// Set up thumbnail clicks
			function thumbClickHandler(event: JQueryMouseEventObject): void {
				event.preventDefault();

				const newIndex = $(this).parent('.gallery__thumb').index();
				activateByIndex(newIndex);

				trackControlEvent('Thumbnail');
			}
			$galleryThumb.on('click', 'a', thumbClickHandler);

			// Set up "previous" button click
			const $prevEl = $elem.find('.gallery__prevBtn');
			const prevClickHandler = (event: JQueryMouseEventObject) => {
				const newIndex = currentIndex
					? currentIndex - 1
					: $galleryThumb.length - 1;

				activateByIndex(newIndex);
				trackControlEvent('Previous');
			};
			$prevEl.on('click', prevClickHandler);

			// Set up "next" button click
			const $nextEl = $elem.find('.gallery__nextBtn');
			const nextClickHandler = (event: JQueryMouseEventObject) => {
				const newIndex = currentIndex < $galleryThumb.length - 1
					? currentIndex + 1
					: 0;

				activateByIndex(newIndex);
				trackControlEvent('Next');
			};
			$nextEl.on('click', nextClickHandler);
		});
	}
}
